//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    tableClass: {
      type: String,
      default: 'table-mobile'
    },
    displays: Array
  }
}
